import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { WindowScrollService } from '@campus/browser';
import { ComponentsModule } from '@campus/components';
import { CookiesModule } from '@campus/cookies';
import { EnvironmentModule } from '@campus/environment';
import { PublicPortalModule } from '@campus/public-portal';

import { SvgModule } from '@campus/svg';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { AppEffectsModule } from './app-effects.module';
import { AppRoutingModule } from './app-routing.module';
import { AppStoreModule } from './app-store.module';
import { AppTokenModule } from './app-token.module';
import { AppComponent } from './app.component';

import { PortalHeaderComponent } from './components/header/header.component';
import { LoginFormComponent } from './components/login/login-form.component';
import { LoginStudentComponent } from './components/login/login-student/login-student.component';
import { LoginTeacherComponent } from './components/login/login-teacher/login-teacher.component';

import { dcrIconService, dcrLogoService } from '@diekeure/dcr-components';
import { PersistedUserCardComponent } from './components/persisted-user-card/persisted-user-card.component';
import { logos } from './logos';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { LegalsHeroComponent } from './pages/legals-page/components/legals-hero/legals-hero.component';
import { LegalsPageAiComponent } from './pages/legals-page/components/legals-page-ai/legals-page-ai.component';
import { LegalsPagePrivacyComponent } from './pages/legals-page/components/legals-page-privacy/legals-page-privacy.component';
import { LegalsPageSalesConditionsComponent } from './pages/legals-page/components/legals-page-sales-conditions/legals-page-sales-conditions.component';
import { LegalsPageTermsOfUseComponent } from './pages/legals-page/components/legals-page-terms-of-use/legals-page-terms-of-use.component';
import { LegalsPageContainerComponent } from './pages/legals-page/legals-page-container.component';
import { LoginComponent } from './pages/login/login.component';
import { PersistedUsersService } from './services/persisted-users.service';
dcrLogoService.registerLogos(logos);

const disableAnimations =
  !('animate' in document.documentElement) || (navigator && /iPhone OS (8|9|10|11|12|13)_/.test(navigator.userAgent));

@NgModule({
  declarations: [
    LoginComponent,
    AppComponent,
    HomePageComponent,
    LoginTeacherComponent,
    LoginStudentComponent,
    LoginFormComponent,
    PersistedUserCardComponent,
    LegalsHeroComponent,
    LegalsPageContainerComponent,
    LegalsPagePrivacyComponent,
    LegalsPageSalesConditionsComponent,
    LegalsPageTermsOfUseComponent,
    LegalsPageAiComponent,
    PortalHeaderComponent,
  ],
  imports: [
    environment.envModules || [],
    BrowserModule,
    AppRoutingModule,
    SvgModule,
    EnvironmentModule.forRoot({
      environmentSvgMapping: environment.svgMapping,
      environmentIconMapping: environment.iconMapping,
      environmentRecaptcha: environment.recaptcha,
      environmentLogin: environment.login,
      environmentApi: environment.api,
      environmentAssets: environment.assets,
      environmentGoogleAnalytics: environment.googleAnalytics,
      environmentLogout: environment.afterLogout,
      environmentWebsite: environment.website,
      environmentPlatform: environment.platform,
    }),
    ReactiveFormsModule,
    BrowserAnimationsModule.withConfig({ disableAnimations }),
    CookiesModule,
    HttpClientModule,
    PublicPortalModule.forRoot({ apiBaseUrl: environment.api.APIBase }),
    ComponentsModule,
    AppTokenModule,
    AppEffectsModule,
    AppStoreModule,
    environment.enableDevTools ? StoreDevtoolsModule.instrument({ connectInZone: true }) : [],
  ],
  providers: [WindowScrollService, PersistedUsersService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {}
